export default __webpack_public_path__ + "static/media/01.f312356d.jpg";